import { Device } from '@/store/device/types';

export const countries = [
	{
		name: 'United States',
		code: 'USA',
	},
	{
		name: 'United Kingdom',
		code: 'GBR',
	},
	{
		name: 'Canada',
		code: 'CAN',
	},
	{
		name: 'Australia',
		code: 'AUS',
	},
	{
		name: 'Afghanistan',
		code: 'AFG',
	},
	{
		name: 'Albania',
		code: 'ALB',
	},
	{
		name: 'Algeria',
		code: 'DZA',
	},
	{
		name: 'American Samoa',
		code: 'ASM',
	},
	{
		name: 'Andorra',
		code: 'AND',
	},
	{
		name: 'Angola',
		code: 'AGO',
	},
	{
		name: 'Anguilla',
		code: 'AIA',
	},
	{
		name: 'Antarctica',
		code: 'ATA',
	},
	{
		name: 'Antigua and Barbuda',
		code: 'ATG',
	},
	{
		name: 'Argentina',
		code: 'ARG',
	},
	{
		name: 'Armenia',
		code: 'ARM',
	},
	{
		name: 'Aruba',
		code: 'ABW',
	},
	{
		name: 'Austria',
		code: 'AUT',
	},
	{
		name: 'Azerbaijan',
		code: 'AZE',
	},
	{
		name: 'Bahamas',
		code: 'BHS',
	},
	{
		name: 'Bahrain',
		code: 'BHR',
	},
	{
		name: 'Bangladesh',
		code: 'BGD',
	},
	{
		name: 'Barbados',
		code: 'BRB',
	},
	{
		name: 'Belarus',
		code: 'BLR',
	},
	{
		name: 'Belgium',
		code: 'BEL',
	},
	{
		name: 'Belize',
		code: 'BLZ',
	},
	{
		name: 'Benin',
		code: 'BEN',
	},
	{
		name: 'Bermuda',
		code: 'BMU',
	},
	{
		name: 'Bhutan',
		code: 'BTN',
	},
	{
		name: 'Bolivia',
		code: 'BOL',
	},
	{
		name: 'Bosnia and Herzegovina',
		code: 'BIH',
	},
	{
		name: 'Botswana',
		code: 'BWA',
	},
	{
		name: 'Bouvet Island',
		code: 'BVT',
	},
	{
		name: 'Brazil',
		code: 'BRA',
	},
	{
		name: 'British Virgin Islands',
		code: 'VGB',
	},
	{
		name: 'British Indian Ocean Territory',
		code: 'IOT',
	},
	{
		name: 'Brunei Darussalam',
		code: 'BRN',
	},
	{
		name: 'Bulgaria',
		code: 'BGR',
	},
	{
		name: 'Burkina Faso',
		code: 'BFA',
	},
	{
		name: 'Burundi',
		code: 'BDI',
	},
	{
		name: 'Cambodia',
		code: 'KHM',
	},
	{
		name: 'Cameroon',
		code: 'CMR',
	},
	{
		name: 'Cape Verde',
		code: 'CPV',
	},
	{
		name: 'Cayman Islands',
		code: 'CYM',
	},
	{
		name: 'Central African Republic',
		code: 'CAF',
	},
	{
		name: 'Chad',
		code: 'TCD',
	},
	{
		name: 'Chile',
		code: 'CHL',
	},
	{
		name: 'China',
		code: 'CHN',
	},
	{
		name: 'Hong Kong',
		code: 'HKG',
	},
	{
		name: 'Macao',
		code: 'MAC',
	},
	{
		name: 'Christmas Island',
		code: 'CXR',
	},
	{
		name: 'Cocos Islands',
		code: 'CCK',
	},
	{
		name: 'Colombia',
		code: 'COL',
	},
	{
		name: 'Comoros',
		code: 'COM',
	},
	{
		name: 'Congo',
		code: 'COD',
	},
	{
		name: 'Cook Islands',
		code: 'COK',
	},
	{
		name: 'Costa Rica',
		code: 'CRI',
	},
	{
		name: "Côte d'Ivoire",
		code: 'CIV',
	},
	{
		name: 'Croatia',
		code: 'HRV',
	},
	{
		name: 'Cuba',
		code: 'CUB',
	},
	{
		name: 'Cyprus',
		code: 'CYP',
	},
	{
		name: 'Czech Republic',
		code: 'CZE',
	},
	{
		name: 'Denmark',
		code: 'DNK',
	},
	{
		name: 'Djibouti',
		code: 'DJI',
	},
	{
		name: 'Dominica',
		code: 'DMA',
	},
	{
		name: 'Dominican Republic',
		code: 'DOM',
	},
	{
		name: 'Ecuador',
		code: 'ECU',
	},
	{
		name: 'Egypt',
		code: 'EGY',
	},
	{
		name: 'El Salvador',
		code: 'SLV',
	},
	{
		name: 'Equatorial Guinea',
		code: 'GNQ',
	},
	{
		name: 'Eritrea',
		code: 'ERI',
	},
	{
		name: 'Estonia',
		code: 'EST',
	},
	{
		name: 'Ethiopia',
		code: 'ETH',
	},
	{
		name: 'Falkland Islands',
		code: 'FLK',
	},
	{
		name: 'Faroe Islands',
		code: 'FRO',
	},
	{
		name: 'Fiji',
		code: 'FJI',
	},
	{
		name: 'Finland',
		code: 'FIN',
	},
	{
		name: 'France',
		code: 'FRA',
	},
	{
		name: 'French Guiana',
		code: 'GUF',
	},
	{
		name: 'French Polynesia',
		code: 'PYF',
	},
	{
		name: 'French Southern Territories',
		code: 'ATF',
	},
	{
		name: 'Gabon',
		code: 'GAB',
	},
	{
		name: 'Gambia',
		code: 'GMB',
	},
	{
		name: 'Georgia',
		code: 'GEO',
	},
	{
		name: 'Germany',
		code: 'DEU',
	},
	{
		name: 'Ghana',
		code: 'GHA',
	},
	{
		name: 'Gibraltar',
		code: 'GIB',
	},
	{
		name: 'Greece',
		code: 'GRC',
	},
	{
		name: 'Greenland',
		code: 'GRL',
	},
	{
		name: 'Grenada',
		code: 'GRD',
	},
	{
		name: 'Guadeloupe',
		code: 'GLP',
	},
	{
		name: 'Guam',
		code: 'GUM',
	},
	{
		name: 'Guatemala',
		code: 'GTM',
	},
	{
		name: 'Guernsey',
		code: 'GGY',
	},
	{
		name: 'Guinea',
		code: 'GIN',
	},
	{
		name: 'Guinea-Bissau',
		code: 'GNB',
	},
	{
		name: 'Guyana',
		code: 'GUY',
	},
	{
		name: 'Haiti',
		code: 'HTI',
	},
	{
		name: 'Heard Island and Mcdonald Islands',
		code: 'HMD',
	},
	{
		name: 'Vatican City',
		code: 'VAT',
	},
	{
		name: 'Honduras',
		code: 'HND',
	},
	{
		name: 'Hungary',
		code: 'HUN',
	},
	{
		name: 'Iceland',
		code: 'ISL',
	},
	{
		name: 'India',
		code: 'IND',
	},
	{
		name: 'Indonesia',
		code: 'IDN',
	},
	{
		name: 'Iran',
		code: 'IRN',
	},
	{
		name: 'Iraq',
		code: 'IRQ',
	},
	{
		name: 'Ireland',
		code: 'IRL',
	},
	{
		name: 'Isle of Man',
		code: 'IMN',
	},
	{
		name: 'Israel',
		code: 'ISR',
	},
	{
		name: 'Italy',
		code: 'ITA',
	},
	{
		name: 'Jamaica',
		code: 'JAM',
	},
	{
		name: 'Japan',
		code: 'JPN',
	},
	{
		name: 'Jersey',
		code: 'JEY',
	},
	{
		name: 'Jordan',
		code: 'JOR',
	},
	{
		name: 'Kazakhstan',
		code: 'KAZ',
	},
	{
		name: 'Kenya',
		code: 'KEN',
	},
	{
		name: 'Kiribati',
		code: 'KIR',
	},
	{
		name: 'North Korea',
		code: 'PRK',
	},
	{
		name: 'South Korea',
		code: 'KOR',
	},
	{
		name: 'Kuwait',
		code: 'KWT',
	},
	{
		name: 'Kyrgyzstan',
		code: 'KGZ',
	},
	{
		name: 'Laos',
		code: 'LAO',
	},
	{
		name: 'Latvia',
		code: 'LVA',
	},
	{
		name: 'Lebanon',
		code: 'LBN',
	},
	{
		name: 'Lesotho',
		code: 'LSO',
	},
	{
		name: 'Liberia',
		code: 'LBR',
	},
	{
		name: 'Libya',
		code: 'LBY',
	},
	{
		name: 'Liechtenstein',
		code: 'LIE',
	},
	{
		name: 'Lithuania',
		code: 'LTU',
	},
	{
		name: 'Luxembourg',
		code: 'LUX',
	},
	{
		name: 'Macedonia',
		code: 'MKD',
	},
	{
		name: 'Madagascar',
		code: 'MDG',
	},
	{
		name: 'Malawi',
		code: 'MWI',
	},
	{
		name: 'Malaysia',
		code: 'MYS',
	},
	{
		name: 'Maldives',
		code: 'MDV',
	},
	{
		name: 'Mali',
		code: 'MLI',
	},
	{
		name: 'Malta',
		code: 'MLT',
	},
	{
		name: 'Marshall Islands',
		code: 'MHL',
	},
	{
		name: 'Martinique',
		code: 'MTQ',
	},
	{
		name: 'Mauritania',
		code: 'MRT',
	},
	{
		name: 'Mauritius',
		code: 'MUS',
	},
	{
		name: 'Mayotte',
		code: 'MYT',
	},
	{
		name: 'Mexico',
		code: 'MEX',
	},
	{
		name: 'Micronesia',
		code: 'FSM',
	},
	{
		name: 'Moldova',
		code: 'MDA',
	},
	{
		name: 'Monaco',
		code: 'MCO',
	},
	{
		name: 'Mongolia',
		code: 'MNG',
	},
	{
		name: 'Montenegro',
		code: 'MNE',
	},
	{
		name: 'Montserrat',
		code: 'MSR',
	},
	{
		name: 'Morocco',
		code: 'MAR',
	},
	{
		name: 'Mozambique',
		code: 'MOZ',
	},
	{
		name: 'Myanmar',
		code: 'MMR',
	},
	{
		name: 'Namibia',
		code: 'NAM',
	},
	{
		name: 'Nauru',
		code: 'NRU',
	},
	{
		name: 'Nepal',
		code: 'NPL',
	},
	{
		name: 'Netherlands',
		code: 'NLD',
	},
	{
		name: 'Netherlands Antilles',
		code: 'ANT',
	},
	{
		name: 'New Caledonia',
		code: 'NCL',
	},
	{
		name: 'New Zealand',
		code: 'NZL',
	},
	{
		name: 'Nicaragua',
		code: 'NIC',
	},
	{
		name: 'Niger',
		code: 'NER',
	},
	{
		name: 'Nigeria',
		code: 'NGA',
	},
	{
		name: 'Niue',
		code: 'NIU',
	},
	{
		name: 'Norfolk Island',
		code: 'NFK',
	},
	{
		name: 'Northern Mariana Islands',
		code: 'MNP',
	},
	{
		name: 'Norway',
		code: 'NOR',
	},
	{
		name: 'Oman',
		code: 'OMN',
	},
	{
		name: 'Pakistan',
		code: 'PAK',
	},
	{
		name: 'Palau',
		code: 'PLW',
	},
	{
		name: 'Palestine',
		code: 'PSE',
	},
	{
		name: 'Panama',
		code: 'PAN',
	},
	{
		name: 'Papua New Guinea',
		code: 'PNG',
	},
	{
		name: 'Paraguay',
		code: 'PRY',
	},
	{
		name: 'Peru',
		code: 'PER',
	},
	{
		name: 'Philippines',
		code: 'PHL',
	},
	{
		name: 'Pitcairn',
		code: 'PCN',
	},
	{
		name: 'Poland',
		code: 'POL',
	},
	{
		name: 'Portugal',
		code: 'PRT',
	},
	{
		name: 'Puerto Rico',
		code: 'PRI',
	},
	{
		name: 'Qatar',
		code: 'QAT',
	},
	{
		name: 'Réunion',
		code: 'REU',
	},
	{
		name: 'Romania',
		code: 'ROU',
	},
	{
		name: 'Russia',
		code: 'RUS',
	},
	{
		name: 'Rwanda',
		code: 'RWA',
	},
	{
		name: 'Saint-Barthélemy',
		code: 'BLM',
	},
	{
		name: 'Saint Helena',
		code: 'SHN',
	},
	{
		name: 'Saint Kitts and Nevis',
		code: 'KNA',
	},
	{
		name: 'Saint Lucia',
		code: 'LCA',
	},
	{
		name: 'Saint-Martin',
		code: 'MAF',
	},
	{
		name: 'Saint Pierre and Miquelon',
		code: 'SPM',
	},
	{
		name: 'Saint Vincent and Grenadines',
		code: 'VCT',
	},
	{
		name: 'Samoa',
		code: 'WSM',
	},
	{
		name: 'San Marino',
		code: 'SMR',
	},
	{
		name: 'Sao Tome and Principe',
		code: 'STP',
	},
	{
		name: 'Saudi Arabia',
		code: 'SAU',
	},
	{
		name: 'Senegal',
		code: 'SEN',
	},
	{
		name: 'Serbia',
		code: 'SRB',
	},
	{
		name: 'Seychelles',
		code: 'SYC',
	},
	{
		name: 'Sierra Leone',
		code: 'SLE',
	},
	{
		name: 'Singapore',
		code: 'SGP',
	},
	{
		name: 'Slovakia',
		code: 'SVK',
	},
	{
		name: 'Slovenia',
		code: 'SVN',
	},
	{
		name: 'Solomon Islands',
		code: 'SLB',
	},
	{
		name: 'Somalia',
		code: 'SOM',
	},
	{
		name: 'South Africa',
		code: 'ZAF',
	},
	{
		name: 'South Sudan',
		code: 'SSD',
	},
	{
		name: 'Spain',
		code: 'ESP',
	},
	{
		name: 'Sri Lanka',
		code: 'LKA',
	},
	{
		name: 'Sudan',
		code: 'SDN',
	},
	{
		name: 'Suriname',
		code: 'SUR',
	},
	{
		name: 'Svalbard',
		code: 'SJM',
	},
	{
		name: 'Swaziland',
		code: 'SWZ',
	},
	{
		name: 'Sweden',
		code: 'SWE',
	},
	{
		name: 'Switzerland',
		code: 'CHE',
	},
	{
		name: 'Syria',
		code: 'SYR',
	},
	{
		name: 'Taiwan',
		code: 'TWN',
	},
	{
		name: 'Tajikistan',
		code: 'TJK',
	},
	{
		name: 'Tanzania',
		code: 'TZA',
	},
	{
		name: 'Thailand',
		code: 'THA',
	},
	{
		name: 'Timor-Leste',
		code: 'TLS',
	},
	{
		name: 'Togo',
		code: 'TGO',
	},
	{
		name: 'Tokelau',
		code: 'TKL',
	},
	{
		name: 'Tonga',
		code: 'TON',
	},
	{
		name: 'Trinidad and Tobago',
		code: 'TTO',
	},
	{
		name: 'Tunisia',
		code: 'TUN',
	},
	{
		name: 'Turkey',
		code: 'TUR',
	},
	{
		name: 'Turkmenistan',
		code: 'TKM',
	},
	{
		name: 'Turks and Caicos Islands',
		code: 'TCA',
	},
	{
		name: 'Tuvalu',
		code: 'TUV',
	},
	{
		name: 'Uganda',
		code: 'UGA',
	},
	{
		name: 'Ukraine',
		code: 'UKR',
	},
	{
		name: 'United Arab Emirates',
		code: 'ARE',
	},
	{
		name: 'Uruguay',
		code: 'URY',
	},
	{
		name: 'US Virgin Islands',
		code: 'VIR',
	},
	{
		name: 'Uzbekistan',
		code: 'UZB',
	},
	{
		name: 'Vanuatu',
		code: 'VUT',
	},
	{
		name: 'Venezuela',
		code: 'VEN',
	},
	{
		name: 'Viet Nam',
		code: 'VNM',
	},
	{
		name: 'Wallis and Futuna Islands',
		code: 'WLF',
	},
	{
		name: 'Western Sahara',
		code: 'ESH',
	},
	{
		name: 'Yemen',
		code: 'YEM',
	},
	{
		name: 'Zambia',
		code: 'ZMB',
	},
	{
		name: 'Zimbabwe',
		code: 'ZWE',
	},
];

export const twoCharCountryCodes: Record<string, string> = {
	BD: 'Bangladesh',
	BE: 'Belgium',
	BF: 'Burkina Faso',
	BG: 'Bulgaria',
	BA: 'Bosnia and Herzegovina',
	BB: 'Barbados',
	WF: 'Wallis and Futuna',
	BL: 'Saint Barthelemy',
	BM: 'Bermuda',
	BN: 'Brunei',
	BO: 'Bolivia',
	BH: 'Bahrain',
	BI: 'Burundi',
	BJ: 'Benin',
	BT: 'Bhutan',
	JM: 'Jamaica',
	BV: 'Bouvet Island',
	BW: 'Botswana',
	WS: 'Samoa',
	BQ: 'Bonaire, Saint Eustatius and Saba ',
	BR: 'Brazil',
	BS: 'Bahamas',
	JE: 'Jersey',
	BY: 'Belarus',
	BZ: 'Belize',
	RU: 'Russia',
	RW: 'Rwanda',
	RS: 'Serbia',
	TL: 'East Timor',
	RE: 'Reunion',
	TM: 'Turkmenistan',
	TJ: 'Tajikistan',
	RO: 'Romania',
	TK: 'Tokelau',
	GW: 'Guinea-Bissau',
	GU: 'Guam',
	GT: 'Guatemala',
	GS: 'South Georgia and the South Sandwich Islands',
	GR: 'Greece',
	GQ: 'Equatorial Guinea',
	GP: 'Guadeloupe',
	JP: 'Japan',
	GY: 'Guyana',
	GG: 'Guernsey',
	GF: 'French Guiana',
	GE: 'Georgia',
	GD: 'Grenada',
	GB: 'United Kingdom',
	GA: 'Gabon',
	SV: 'El Salvador',
	GN: 'Guinea',
	GM: 'Gambia',
	GL: 'Greenland',
	GI: 'Gibraltar',
	GH: 'Ghana',
	OM: 'Oman',
	TN: 'Tunisia',
	JO: 'Jordan',
	HR: 'Croatia',
	HT: 'Haiti',
	HU: 'Hungary',
	HK: 'Hong Kong',
	HN: 'Honduras',
	HM: 'Heard Island and McDonald Islands',
	VE: 'Venezuela',
	PR: 'Puerto Rico',
	PS: 'Palestinian Territory',
	PW: 'Palau',
	PT: 'Portugal',
	SJ: 'Svalbard and Jan Mayen',
	PY: 'Paraguay',
	IQ: 'Iraq',
	PA: 'Panama',
	PF: 'French Polynesia',
	PG: 'Papua New Guinea',
	PE: 'Peru',
	PK: 'Pakistan',
	PH: 'Philippines',
	PN: 'Pitcairn',
	PL: 'Poland',
	PM: 'Saint Pierre and Miquelon',
	ZM: 'Zambia',
	EH: 'Western Sahara',
	EE: 'Estonia',
	EG: 'Egypt',
	ZA: 'South Africa',
	EC: 'Ecuador',
	IT: 'Italy',
	VN: 'Vietnam',
	SB: 'Solomon Islands',
	ET: 'Ethiopia',
	SO: 'Somalia',
	ZW: 'Zimbabwe',
	SA: 'Saudi Arabia',
	ES: 'Spain',
	ER: 'Eritrea',
	ME: 'Montenegro',
	MD: 'Moldova',
	MG: 'Madagascar',
	MF: 'Saint Martin',
	MA: 'Morocco',
	MC: 'Monaco',
	UZ: 'Uzbekistan',
	MM: 'Myanmar',
	ML: 'Mali',
	MO: 'Macao',
	MN: 'Mongolia',
	MH: 'Marshall Islands',
	MK: 'Macedonia',
	MU: 'Mauritius',
	MT: 'Malta',
	MW: 'Malawi',
	MV: 'Maldives',
	MQ: 'Martinique',
	MP: 'Northern Mariana Islands',
	MS: 'Montserrat',
	MR: 'Mauritania',
	IM: 'Isle of Man',
	UG: 'Uganda',
	TZ: 'Tanzania',
	MY: 'Malaysia',
	MX: 'Mexico',
	IL: 'Israel',
	FR: 'France',
	IO: 'British Indian Ocean Territory',
	SH: 'Saint Helena',
	FI: 'Finland',
	FJ: 'Fiji',
	FK: 'Falkland Islands',
	FM: 'Micronesia',
	FO: 'Faroe Islands',
	NI: 'Nicaragua',
	NL: 'Netherlands',
	NO: 'Norway',
	NA: 'Namibia',
	VU: 'Vanuatu',
	NC: 'New Caledonia',
	NE: 'Niger',
	NF: 'Norfolk Island',
	NG: 'Nigeria',
	NZ: 'New Zealand',
	NP: 'Nepal',
	NR: 'Nauru',
	NU: 'Niue',
	CK: 'Cook Islands',
	XK: 'Kosovo',
	CI: 'Ivory Coast',
	CH: 'Switzerland',
	CO: 'Colombia',
	CN: 'China',
	CM: 'Cameroon',
	CL: 'Chile',
	CC: 'Cocos Islands',
	CA: 'Canada',
	CG: 'Republic of the Congo',
	CF: 'Central African Republic',
	CD: 'Democratic Republic of the Congo',
	CZ: 'Czech Republic',
	CY: 'Cyprus',
	CX: 'Christmas Island',
	CR: 'Costa Rica',
	CW: 'Curacao',
	CV: 'Cape Verde',
	CU: 'Cuba',
	SZ: 'Swaziland',
	SY: 'Syria',
	SX: 'Sint Maarten',
	KG: 'Kyrgyzstan',
	KE: 'Kenya',
	SS: 'South Sudan',
	SR: 'Suriname',
	KI: 'Kiribati',
	KH: 'Cambodia',
	KN: 'Saint Kitts and Nevis',
	KM: 'Comoros',
	ST: 'Sao Tome and Principe',
	SK: 'Slovakia',
	KR: 'South Korea',
	SI: 'Slovenia',
	KP: 'North Korea',
	KW: 'Kuwait',
	SN: 'Senegal',
	SM: 'San Marino',
	SL: 'Sierra Leone',
	SC: 'Seychelles',
	KZ: 'Kazakhstan',
	KY: 'Cayman Islands',
	SG: 'Singapore',
	SE: 'Sweden',
	SD: 'Sudan',
	DO: 'Dominican Republic',
	DM: 'Dominica',
	DJ: 'Djibouti',
	DK: 'Denmark',
	VG: 'British Virgin Islands',
	DE: 'Germany',
	YE: 'Yemen',
	DZ: 'Algeria',
	US: 'United States',
	UY: 'Uruguay',
	YT: 'Mayotte',
	UM: 'United States Minor Outlying Islands',
	LB: 'Lebanon',
	LC: 'Saint Lucia',
	LA: 'Laos',
	TV: 'Tuvalu',
	TW: 'Taiwan',
	TT: 'Trinidad and Tobago',
	TR: 'Turkey',
	LK: 'Sri Lanka',
	LI: 'Liechtenstein',
	LV: 'Latvia',
	TO: 'Tonga',
	LT: 'Lithuania',
	LU: 'Luxembourg',
	LR: 'Liberia',
	LS: 'Lesotho',
	TH: 'Thailand',
	TF: 'French Southern Territories',
	TG: 'Togo',
	TD: 'Chad',
	TC: 'Turks and Caicos Islands',
	LY: 'Libya',
	VA: 'Vatican',
	VC: 'Saint Vincent and the Grenadines',
	AE: 'United Arab Emirates',
	AD: 'Andorra',
	AG: 'Antigua and Barbuda',
	AF: 'Afghanistan',
	AI: 'Anguilla',
	VI: 'U.S. Virgin Islands',
	IS: 'Iceland',
	IR: 'Iran',
	AM: 'Armenia',
	AL: 'Albania',
	AO: 'Angola',
	AQ: 'Antarctica',
	AS: 'American Samoa',
	AR: 'Argentina',
	AU: 'Australia',
	AT: 'Austria',
	AW: 'Aruba',
	IN: 'India',
	AX: 'Aland Islands',
	AZ: 'Azerbaijan',
	IE: 'Ireland',
	ID: 'Indonesia',
	UA: 'Ukraine',
	QA: 'Qatar',
	MZ: 'Mozambique',
};

export const eeaCountries = new Set([
	'AUT',
	'BEL',
	'BGR',
	'HRV',
	'CYP',
	'CZE',
	'DNK',
	'EST',
	'FIN',
	'FRA',
	'DEU',
	'GRC',
	'HUN',
	'IRL',
	'ITA',
	'LVA',
	'LTU',
	'LUX',
	'MLT',
	'NLD',
	'POL',
	'PRT',
	'ROU',
	'SVK',
	'SVN',
	'ESP',
	'SWE',
	'GBR',
	'ISL',
	'LIE',
	'NOR',
]);

export const getCountryNameFromDevice = (device: Device | null) => {
	return device?.ip_country ? twoCharCountryCodes[device?.ip_country?.toUpperCase()] : null;
};

export const getThreeCharCountryCodeFromCountryName = (countryName: string | null) => {
	return countries.find(({ name }) => name === countryName)?.code ?? 'USA';
};
